import { Badge, Col, Divider, Input, Row } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { COLORS } from "../constants/Colors";
import Typography from "./Typography";
import { FormattedMessage, useIntl } from "react-intl";
import filterimg from "../assets/Filter_2.svg";
import useIsDesktop from "../utils/hooks/useIsDesktop";
import { useIsMoblie } from "../utils/hooks/useMobile";

const SearchCardWithFilter = (props) => {
  const { handleSerchQueue, onToggleFilter, filterDot } = props;
  const intl = useIntl();
  const isDesktop = useIsDesktop();
  const isMoblie = useIsMoblie();
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        borderRadius: "8px 8px 0px 0px",
        backgroundColor: "white",
        width: "100%",
      }}
    >
      <div className="d-flex flex-column justify-content-center text-left w-100">
        <Typography className="py-3 px-4" isBold color={COLORS.Dark}>
          <FormattedMessage id="SearchParking" defaultMessage="ค้นหาช่องจอด" />
        </Typography>
        <Divider className="m-0" />
        {/* <div
          className="py-3 px-4"
          style={{ display: "flex", justifyContent: "space-between" }}
        > */}
        <Row className="py-3 px-4" gutter={[16, 16]}>
          <Col xxl={21} xl={21} lg={19} md={20} sm={19} xs={19}>
            <Input
              allowClear
              style={{
                borderRadius: "20px",
                // width: isDesktop ? "85%" : "82%",
                width: "100%",
                marginRight: "5px",
                backgroundColor: "#F8F8F8",
                height: "35px",
                margintop: "5xp",
                border: "0px",
              }}
              placeholder={intl.formatMessage({
                id: "SearchParking",
                defaultMessage: "ค้นหาช่องจอด",
              })}
              onChange={(e) => handleSerchQueue(e.target.value)}
              suffix={
                <div>
                  <SearchOutlined
                    style={{
                      color: "rgba(0,0,0,.45)",
                    }}
                  />
                </div>
              }
            />
          </Col>

          <Col xxl={3} xl={3} lg={5} md={4} sm={5} xs={5}>
            <div>
              <span
                style={{
                  display: "flex",
                  backgroundColor: "#F8F8F8",
                  borderRadius: "20px",
                  padding: isDesktop ? "5px 22px" : "5px 15px",
                  cursor: "pointer",
                  textAlign: "center",
                  justifyContent: "center",
                  // width: isDesktop ? "auto" : "15%",
                  width: "100%",
                  minWidth: "auto",
                  // maxWidth: 'auto',
                  height: "35px",
                }}
                onClick={onToggleFilter}
              >
                <Badge dot={filterDot} color={COLORS.Primary} status="processing">
                  <img src={filterimg} style={{ width: "20px" }} />
                </Badge>
                {isMoblie ? null : (
                  <span style={{ color: "#898989", marginLeft: "7px" }}>
                    <FormattedMessage
                      id="filterTracking"
                      defaultMessage="Filter"
                    />
                  </span>
                )}
              </span>
            </div>
          </Col>
        </Row>

        {/* </div> */}
      </div>
    </div>
  );
};

export default SearchCardWithFilter;
